<template>
  <div :style="cssVars">
    <div class="video" :class="{ 'is-no-border-radius': isNoBorderRadius }">
      <figure>
        <video
          :key="refreshKey"
          ref="video"
          :aria-label="alt || 'Video'"
          :class="['lazy', { 'is-no-border-radius': isNoBorderRadius }]"
          muted
          playsinline
          preload="metadata"
          :loop="loop"
          :autoplay="autoplay"
          :controls="false"
          loading="lazy"
          @loadeddata="loadeddata"
          @pause="isPlaying = false"
          @play="isPlaying = true"
        >
          <!-- <source :data-src="videos?.videoMobile" media="(max-width: 768px)" type="video/mp4">
          <source :data-src="videos?.videoMain" type="video/mp4"> -->
          <source v-if="videos?.videoMobile" :src="videos.videoMobile" media="(max-width: 768px)" type="video/mp4">
          <source v-if="videos?.videoMain" :src="videos.videoMain" type="video/mp4">
        </video>
      </figure>

      <div
        v-if="isLoaded"
        :class="['video-button-container', 'play', { hide: isPlaying }]"
        @click="playVideo"
      >
        <div class="play-button">
          <play-button />
        </div>
      </div>
      <div
        v-if="isLoaded"
        class="video-button-container pause"
        @click="stopVideo"
      />
    </div>
    <div :class="['placeholder-wrapper', { 'is-no-border-radius': isNoBorderRadius }]">
      <b-skeleton
        loading
        class="skeleton-aspect-ratio"
        width="100%"
        height="100%"
      />
    </div>
  </div>
</template>

<script>
// import lazyVideo from 'marketplace-front-core/utils/lazyVideo'
import playButton from 'marketplace-front-core/assets/generate-icons/icons/play-button.svg?inline'
import { contentFindContent, contentFindOption } from '../../../plugins/content'

export default {
  components: {
    playButton
  },
  props: {
    aspectRatio: {
      type: String,
      default: null
    },
    aspectRatioMobile: {
      type: String,
      default: null
    },
    value: {
      type: Object,
      default: null
    },
    isNoBorderRadius: {
      type: Boolean,
      defalt: false
    }
  },
  data () {
    return {
      isPlaying: this.autoplay,
      refreshKey: 0,
      isLoaded: false
    }
  },
  computed: {
    videos () {
      const main = contentFindContent(this.value.content, 'main')
      const mobile = contentFindContent(this.value.content, 'mobile') || null
      let videoMain; let videoMobile = null

      if (main?.fileData?.isVideo) {
        videoMain = main?.fileData?.isVideo?.video || ''
      }

      if (mobile?.fileData?.isVideo) {
        videoMobile = mobile?.fileData?.isVideo?.video || ''
      }
      return { videoMain, videoMobile }
    },
    alt () {
      return contentFindOption(this.value.options, 'alt').value
    },
    autoplay () {
      return contentFindOption(this.value.options, 'autoplay').value
    },
    loop () {
      return contentFindOption(this.value.options, 'loop').value
    },
    aspectRatioValue () {
      return this.aspectRatio || 'auto'
    },
    aspectRatioMobileValue () {
      return this.aspectRatioMobile ? this.aspectRatioMobile : this.aspectRatio ? this.aspectRatio : 'auto'
    },
    cssVars () {
      return {
        '--aspect-ratio': this.aspectRatioValue,
        '--aspect-ratio-mobile': this.aspectRatioMobileValue
      }
    }
  },
  watch: {
    value: {
      handler () {
        this.refreshKey++
        this.isLoaded = false
        this.isPlaying = this.autoplay
      },
      deep: true
    }
  },
  mounted () {
    // if (this.$refs.video) {
    //   if (Array.isArray(this.$refs.video)) {
    //     this.$refs.video.forEach((video) => {
    //       lazyVideo(video)
    //     })
    //   } else {
    //     lazyVideo(this.$refs.video)
    //   }
    // }
  },
  methods: {
    playVideo () {
      if (this.$refs.video) {
        this.$refs.video.play()
      }
    },
    loadeddata () {
      this.isLoaded = true
    },
    stopVideo () {
      if (this.$refs.video) {
        this.$refs.video.pause()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.video {
  position: relative;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  height: auto;
  aspect-ratio: var(--aspect-ratio);
  @include mobile {
    aspect-ratio: var(--aspect-ratio-mobile);
  }
  figure {
    position: absolute;
    top: 0;
    bottom: 0;
    aspect-ratio: var(--aspect-ratio);

    @include mobile {
      aspect-ratio: var(--aspect-ratio-mobile);
    }

    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
  video {
    display: block;
    object-fit: cover;
    border-radius: 20px;
    overflow: hidden;
    z-index: 100;
    pointer-events: none;
    aspect-ratio: var(--aspect-ratio);

    @include mobile {
      aspect-ratio: var(--aspect-ratio-mobile);
    }

    &::-webkit-media-controls,
    &::-webkit-media-controls-panel,
    &::-webkit-media-controls-play-button,
    &::-webkit-media-controls-overlay-play-button,
    &::-webkit-media-controls-start-playback-button {
      display: none !important;
    }
  }
  .video-button-container {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    // background-color: rgba(black, 0.06);
    cursor: pointer;
    &.play {
      z-index: 10;
    }
    &.pause {
      z-index: 9;
    }
    &.hide {
      display: none;
    }
    .play-button{
      display: flex;
      align-items: center;
      justify-content: center;

      :deep(svg) {
        min-width: 64px;
        min-height: 64px;
        width: 80%;
      }
    }
  }
}

.placeholder-wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 20px;
  width: 100%;
  aspect-ratio: var(--aspect-ratio);
  overflow: hidden;
  z-index: -1;
  @include mobile {
    aspect-ratio: var(--aspect-ratio-mobile);
  }
  .is-animated {
    height: 100%;
  }
}

.b-skeleton {
  height: 100%;
}
</style>
